import * as gabito from './eventSenders/gabito';
import { getPublicRuntimeConfigValue } from '../config';
import { EventData } from '@spotify-internal/event-sender';

export enum Tracker {
  Gabito = 1,
  DataLayer = 2,
}

export type GabitoEventDefinition = {
  tracker: Tracker.Gabito;
  eventData: EventData;
  options?: {
    authorize?: boolean;
    flush?: boolean;
  };
};

export type DataLayerEventDefinition = {
  tracker: Tracker.DataLayer;
  eventData: object;
};

export type EventDefinition = GabitoEventDefinition | DataLayerEventDefinition;

const publishEnabled = getPublicRuntimeConfigValue<boolean>(
  'analytics.gabito.enabled',
);

export const trackEvent = (eventDefinitions: EventDefinition[]) => {
  return Promise.all(
    eventDefinitions.map(eventDefinition => {
      switch (eventDefinition.tracker) {
        case Tracker.Gabito:
          if (
            publishEnabled &&
            // only emit events when on www.spotify.com
            typeof window !== 'undefined' &&
            window.location.host === 'www.spotify.com'
          ) {
            return gabito
              .getEventSender()
              .then(eventSender =>
                eventSender.send(
                  eventDefinition.eventData,
                  eventDefinition.options,
                ),
              );
          }
          // eslint-disable-next-line no-console
          console.info('Gabito event: ', eventDefinition.eventData);
          return Promise.resolve();

        default:
          throw new Error(`Unknown tracker for event: ${eventDefinition}`);
      }
    }),
  );
};
